import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input, Alert, message } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import {
  req_list_ssp_target_goal_limit,
  req_edit_ssp_target_goal,
} from "../../api";

class SchoolPlanTargetHoldon extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    totalTarget: 1,
    totalPlan: 0,
    totalConfident: 0,
  };

  componentWillMount() {
    this.api_item_list();
  }

  //////////
  api_item_list = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_target_goal_limit(
      userCode,
      "VIEWER",
      planAcademicYear,
      "LIMIT",
      token
    );
    if (result.total > 0) {
      const items = result.data;
      //console.log(items);
      const totalTarget = items.reduce((accumulator, object) => {
        return accumulator + object.PlanALLApprovedTotal;
      }, 0);
      const totalPlan = items.reduce((accumulator, object) => {
        return accumulator + object.PlanQuotaTotal;
      }, 0);
      const totalConfident = items.reduce((accumulator, object) => {
        return accumulator + object.ConfidentQuotaTotal;
      }, 0);
      this.setState({ data: items, totalTarget, totalPlan, totalConfident });
      // console.log(totalTarget);
    } else {
      const items = [];
      this.setState({
        data: items,
        totalTagert: 0,
        totalPlan: 0,
        totalConfident: 0,
      });
    }
  };

  api_edit_item = async (row) => {
    const { token } = this.props.user;
    await req_edit_ssp_target_goal(row, token);
    this.handle_data_refresh();
  };

  //////////
  handle_data_refresh = () => {
    //this.api_list_studentsource_noloading();
    this.api_item_list();
    console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const { userCode } = this.props.user;
    let value = e.target.value;
    let getValue = parseInt(value, 10);

    if (isNaN(getValue)) {
      getValue = 0;
    }

    if (getValue <= 100 && getValue >= 0) {
      const item = {
        Gid: target_key,
        HoldonTotal: getValue,
        HoldonReporterId: userCode,
        condition: target_field,
      };
      //console.log(target_key)
      this.api_edit_item(item);
    } else {
      message.info("數字僅能介於0至100");
    }
  };

  //////////
  render() {
    const {
      planAcademicYear,
      data,
      loading,
      totalTarget,
      totalPlan,
      totalConfident,
    } = this.state;
    const columns = [
      {
        title: "計畫學年",
        align: "center",
        responsive: ["lg"],
        dataIndex: "PlanAcademicYear",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeShortName",
        responsive: ["lg"],
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學制",
        align: "center",
        dataIndex: "EducationalSystemTwName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "DeptmentShortName",
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <>
            教育部<br></br>核召人數
          </>
        ),
        dataIndex: "PlanALLApprovedTotal",
        width: 100,
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}人</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>規劃人數
          </>
        ),
        align: "center",
        width: 100,
        responsive: ["lg"],
        dataIndex: "PlanQuotaTotal",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                fontWeight: 900,
                color: textColor,
              },
            },
            children: <div>{text}人</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>規劃率
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "PlanQuotaRatio",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background: text >= 110 ? "#D1FABB" : "#FAC4BB",
              },
            },
            children: <div>{text}%</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>預收達成人數
          </>
        ),
        align: "center",
        width: 100,
        responsive: ["lg"],
        dataIndex: "ConfidentQuotaTotal",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                fontWeight: 900,
                color: textColor,
              },
            },
            children: <div>{text}人</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>預達率
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "ConfidentQuotaRatio",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background: text >= 80 ? "#D1FABB" : "#FAC4BB",
              },
            },
            children: <div>{text}%</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>有把握招收數
          </>
        ),
        width: 100,
        align: "left",
        fixed: "true",
        render: (item) => {
          const { HoldonTotal, Gid } = item;
          return (
            <>
              <Input
                type="number"
                placeholder="人數"
                style={{
                  fontWeight: 900,
                  backgroundColor: "LightYellow",
                  color: "green",
                }}
                defaultValue={HoldonTotal}
                onChange={(e) => this.handle_ui_field_change(Gid, "HOLDON", e)}
              />
            </>
          );
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>滿招率
          </>
        ),
        align: "center",
        dataIndex: "FullQuotaRatio",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background: text >= 90 ? "#D1FABB" : "#FAC4BB",
              },
            },
            children: <div>{text}%</div>,
          };
        },
      },
    ];

    return (
      <>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",
            marginBottom: "4px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        <Alert
          message={
            totalTarget > 0 ? (
              <>
                <span style={{ color: "orange", fontWeight: 900 }}>
                  教育部核定人數：{totalTarget}人
                </span>{" "}
                |{" "}
                <span style={{ color: "blue", fontWeight: 900 }}>
                  當前規劃人數： {totalPlan}人
                </span>{" "}
                |{" "}
                <span style={{ color: "green", fontWeight: 900 }}>
                  預收達成人數： {totalConfident}人
                </span>{" "}
              </>
            ) : (
              <></>
            )
          }
          type="error"
        />
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SchoolPlanTargetHoldon);
